/**
 * @generated SignedSource<<8e05ea7158cfafc5897039033e073763>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type PhaseFinancialBreakdownType = "PHASE" | "NO_PHASE" | "PROJECT_TIME_REG" | "OFFSET" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PhaseLoader_viewer$data = {
  readonly id: string;
  readonly company: {
    readonly currency: string | null;
  } | null;
  readonly project: {
    readonly budgetBaseCurrency: number | null;
    readonly phaseFinancialBreakdown: ReadonlyArray<{
      readonly breakdownType: PhaseFinancialBreakdownType | null;
      readonly phase: {
        readonly id: string;
        readonly name: string | null;
        readonly sortOrder: number | null;
        readonly startDay: number | null;
        readonly startMonth: number | null;
        readonly startYear: number | null;
        readonly deadlineDay: number | null;
        readonly deadlineMonth: number | null;
        readonly deadlineYear: number | null;
        readonly progress: number | null;
      } | null;
      readonly financialNumbers: {
        readonly " $fragmentSpreads": FragmentRefs<"ProjectPortfolioPeriodRow_financialNumbers">;
      } | null;
    } | null>;
  } | null;
  readonly " $fragmentType": "PhaseLoader_viewer";
};
export type PhaseLoader_viewer$key = {
  readonly " $data"?: PhaseLoader_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhaseLoader_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "deliverableId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endDay"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endMonth"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endYear"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "excludeOpportunityActuals"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "ignoreBaselineWinChance"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startDay"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startMonth"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startYear"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhaseLoader_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "internalId",
          "variableName": "projectId"
        }
      ],
      "concreteType": "ProjectType",
      "kind": "LinkedField",
      "name": "project",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "budgetBaseCurrency",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "deliverableId",
              "variableName": "deliverableId"
            },
            {
              "kind": "Variable",
              "name": "endDay",
              "variableName": "endDay"
            },
            {
              "kind": "Variable",
              "name": "endMonth",
              "variableName": "endMonth"
            },
            {
              "kind": "Variable",
              "name": "endYear",
              "variableName": "endYear"
            },
            {
              "kind": "Variable",
              "name": "excludeOpportunityActuals",
              "variableName": "excludeOpportunityActuals"
            },
            {
              "kind": "Literal",
              "name": "filterRowsWithNoValues",
              "value": true
            },
            {
              "kind": "Variable",
              "name": "ignoreBaselineWinChance",
              "variableName": "ignoreBaselineWinChance"
            },
            {
              "kind": "Variable",
              "name": "startDay",
              "variableName": "startDay"
            },
            {
              "kind": "Variable",
              "name": "startMonth",
              "variableName": "startMonth"
            },
            {
              "kind": "Variable",
              "name": "startYear",
              "variableName": "startYear"
            }
          ],
          "concreteType": "PhaseFinancialBreakdown",
          "kind": "LinkedField",
          "name": "phaseFinancialBreakdown",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "breakdownType",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PhaseType",
              "kind": "LinkedField",
              "name": "phase",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sortOrder",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startDay",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startMonth",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startYear",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "deadlineDay",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "deadlineMonth",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "deadlineYear",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "progress",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialNumbers",
              "kind": "LinkedField",
              "name": "financialNumbers",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ProjectPortfolioPeriodRow_financialNumbers"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "4254431eb47d60262e103cb36ba0de2b";

export default node;
